import React from 'react';

import Div from '../div';

export default ({ params }) =>
    <Div setup='c center center' hView='100'>
        <Div h='20'>{ params.msg }</Div>
    </Div>
